import React from 'react';
import cn from 'classnames';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const OnboardingFooter = ({ onExtraButtonClick, extraButtonTitle, isFooterButtonActive, isLoading, onButtonClick }) => (
  <footer data-bem="OnboardingFooter" className="footer">
    <div
      className={cn({
        'footer-content-buttons': extraButtonTitle,
        'footer-content-button': !extraButtonTitle,
      })}
    >
      {fromAnyToBool(onExtraButtonClick && extraButtonTitle) && (
        <button data-bem="OnboardingFooter__extra-footer-button" className="footer-text-button" onClick={onExtraButtonClick}>
          <span data-bem="OnboardingFooter__extra-footer-button-icon" className="plus-ico">
            +
          </span>
          <span data-bem="OnboardingFooter__extra-footer-button-text" className="footer-text">
            {extraButtonTitle}
          </span>
        </button>
      )}

      <button
        data-bem="Footer__button"
        data-is-active={String(isFooterButtonActive)}
        data-is-disabled={String(!isFooterButtonActive)}
        className={cn({
          'lrg-icon-button button-primary': true,
          disabled: !isFooterButtonActive || isLoading,
        })}
        onClick={onButtonClick}
      >
        {isLoading ? (
          <div className="loader">
            <svg className="circular">
              <circle className="path" cx="50" cy="50" r="12" fill="none" strokeWidth="2" strokeMiterlimit="10" stroke="white" />
            </svg>
          </div>
        ) : (
          <span className="ic-sml ic-arrow-forward-white" />
        )}
      </button>
    </div>
  </footer>
);

export default OnboardingFooter;
